import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getAllowedMimeTypesService } from '../services/contentService';

// async thunks
export const updateAllowedMimeTypes = createAsyncThunk(
  'system/updateAllowedMimeTypes',
  async (mimeTypes) => {
    const response = await getAllowedMimeTypesService(mimeTypes);
    return response.data;
  }
);

const initialState = {
  menuOpen: false,
  blockUI: false,
  modal: {
    modalType: null,
    modalProps: {},
    show: false,
  },
  allowedFileMimeTypes: {},
  showLoadOverlay: false,
  contextMenuOpen: false,
};

// slice
const systemSlice = createSlice({
  name: 'system',
  initialState,
  reducers: {
    toggleMenu(state) {
      state.menuOpen = !state.menuOpen;
    },
    systemBlockUiOn(state) {
      state.blockUI = true;
    },
    systemBlockUiOff(state) {
      state.blockUI = false;
    },
    systemShowLoadOverlay(state) {
      state.showLoadOverlay = true;
    },
    systemHideLoadOverlay(state) {
      state.showLoadOverlay = false;
    },
    systemAllowedMimeTypesReceived(state, action) {
      state.allowedFileMimeTypes = {
        ...state.allowedFileMimeTypes,
        ...action.payload.mimeTypes,
      };
    },
    systemShowContextMenu(state) {
      state.contextMenuOpen = true;
    },
    systemHideContextMenu(state) {
      state.contextMenuOpen = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateAllowedMimeTypes.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(updateAllowedMimeTypes.fulfilled, (state, action) => {
        state.allowedFileMimeTypes = {
          ...state.allowedFileMimeTypes,
          ...action.payload,
        };
        state.isLoading = false;
      })
      .addCase(updateAllowedMimeTypes.rejected, (state) => {
        state.isLoading = false;
      });
  },
});

export default systemSlice.reducer;
export const {
  toggleMenu,
  systemBlockUiOn,
  systemBlockUiOff,
  systemShowLoadOverlay,
  systemHideLoadOverlay,
  systemAllowedMimeTypesReceived,
  systemShowContextMenu,
  systemHideContextMenu,
} = systemSlice.actions;

// selectors
export const systemSelector = {
  get(state) {
    return state.system;
  },
  menuOpen(state) {
    return state.system.menuOpen;
  },
  blockUI(state) {
    return state.system.blockUI;
  },
};